import { GetCrsInfoByKey } from "../components/MagicCursor";
import { CursorState } from "../providers/CursorProvider"

const foundCrsKey = 'lst-fnd-crs-stt';
const foundPassKey = 'lst-fnd-crs-pss';

export function SMTHNG() {
    const crsString : string|null = localStorage.getItem(foundCrsKey);
    const pssString : string|null = localStorage.getItem(foundPassKey);
    if (crsString == null || pssString == null)
        return <div />

    const info = GetCrsInfoByKey(crsString);

    return <div className="page-basic center-all v-box">
        <img src={info.icon} />
        <h2>You found ... { info.name }</h2>
        <p>The password to use it is...</p>
        { pssString }
    </div>
}